import { render, staticRenderFns } from "./CndPortalDocumentosView.vue?vue&type=template&id=6bf61de2&"
import script from "./CndPortalDocumentosView.vue?vue&type=script&lang=js&"
export * from "./CndPortalDocumentosView.vue?vue&type=script&lang=js&"
import style0 from "./CndPortalDocumentosView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports